<template>
  <article>
    <slot :data="resolvedData" :fetchData="fetchData">
      <div style="display:flex; justify-content: center;">
        <img src="/loader.svg" height="400" width="300" />
      </div>
    </slot>
  </article>
</template>

<script>
import axios from "axios";
import { memoize } from "@/utils/memoize";
import { auth_header } from "@/components/SpotifyButton.vue";

export default {
  name: "GeneralInfo",
  props: ["artist", "dataUrls", "toggleInfoIsResolved"],
  data: function() {
    return {
      shoTemplate: false,
      resolvedData: undefined
    };
  },

  methods: {
    async fetchData() {
      const dataUrls = this.dataUrls;
      const keys = Object.keys(dataUrls);
      let promises = [];
      promises = keys.map(p => {
        const u = dataUrls[p];
        const options = u.match("api.spotify") ? { headers: auth_header } : {};
        return memoize(u, fetch, [u], options).then(data => {
          return data.json();
        });
      });

      Promise.allSettled(promises).then(d => {
        const resolvedData = d.reduce((acc, data, index) => {
          const key = keys[index];
          acc[key] = data.value;
          return acc;
        }, {});
        this.resolvedData = resolvedData;
        this.$emit("toggleInfoIsResolved");
      });
    }
  },

  mounted() {
    this.fetchData(this.artist);
  }
};
</script>

<style>
#info {
  position: absolute;
  bottom: 50%;
  width: 100%;
  z-index: 11000;
  height: 50%;
  overflow: auto;
  background: rgba(255, 255, 255, 0.9);
  padding: 12px;
  border-bottom: 3px solid #c53526;
  text-align: left;
}
</style>
